import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

import App from './App'
import store from './store'
import api from '../api'
import router from './router'
import i18n from '../assets/i18n'

import './plugin/element'
import './plugin/sentry'
import registerServiceWorker from './registerServiceWorker'
import './utils/compatibility'

import { appOpenBlankUrl } from './utils/utils'

import AppMenu from './components/AppMenu.vue'
import logClickEvent from './utils/logClickEvent'
import { messageMixin } from './mixins/messageMixin.js'

import '@/icons' // icon

Vue.config.ignoredElements = ['wx-open-launch-app']

Vue.component('AppMenu', AppMenu)
Vue.component('v-fragment', {
  functional: true,
  render: function (createElement, context) {
    return context.children
  },
})

VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

Vue.mixin(messageMixin)

Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 99999,
  },
})

Vue.prototype.$api = api
Vue.prototype.$isMobile = () => {
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  return isMobile
}
Vue.prototype.$appOpenBlankUrl = appOpenBlankUrl

Vue.prototype.$isElectron = !!process.env.IS_ELECTRON
Vue.prototype.$buildTime = process.env.BUILD_TIME
if (!process.env.IS_ELECTRON) {
  registerServiceWorker()
} else {
  Vue.prototype.$isMac = process.platform === 'darwin'
}

Vue.filter('NumFormat', function (value) {
  if (!value) return '0'
  // value 大于 100000 时，显示为 100k
  if (value > 100000) {
    return (value / 1000).toFixed(1) + 'k'
  }
  const intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
  return intPartFormat
})

Vue.directive('baiduEventTracking', {
  bind(el, binding) {
    el.addEventListener('click', function () {
      const {
        query: { from },
      } = router.history.current
      logClickEvent(binding.value.feature, binding.value.action, from)
    })
  },
})

const app = new Vue({
  el: '#app',
  store,
  i18n,
  router,
  render: (h) => h(App),
})

export default app

Vue.config.silent = true
